import { Sparkles } from "lucide-react";
import { painPoints } from "./homeData";

export function ProblemSection() {
  return (
    <section className="bg-navy-band py-20 md:py-24 border-y border-navy-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <p className="overline mb-3">The problem</p>
          <h2 className="h-display text-3xl md:text-4xl">
            Leasehold cases are complex. <span className="text-navy-400">Your clients feel it.</span>
          </h2>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4">
          {painPoints.map((p) => (
            <div key={p.text} className="card-soft p-6 flex items-start gap-4" data-testid={`problem-${p.text.substring(0, 20)}`}>
              <span className="w-10 h-10 rounded-lg bg-rose-50 text-rose-600 flex items-center justify-center shrink-0">
                <p.icon className="w-5 h-5" strokeWidth={1.8} />
              </span>
              <p className="text-navy-800 leading-relaxed">{p.text}</p>
            </div>
          ))}
        </div>
        <div className="mt-10 flex items-center gap-3 max-w-3xl">
          <Sparkles className="w-5 h-5 text-emerald-600 shrink-0" strokeWidth={1.8} />
          <p className="text-lg text-navy-900 font-medium">LeaseFlow replaces confusion with clarity.</p>
        </div>
      </div>
    </section>
  );
}
